<script setup lang="ts">
import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { useGameStore } from '@/stores/gameStore.ts'

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

const gameStore = useGameStore();
</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.player!.profileImage"
    :toast-text="'Research stolen!'"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="gameStore.player!.profileImage"
      :header="'Research stolen!'"
    >
      <div>
        An enemy spy has stolen research documents from your empire.
        <div class="pt-2">
          Your research was reduced by <span class="text-red-500">{{ props.newsItem.contentData.science_stolen }}</span> points.
        </div>
      </div>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>